<nz-card [nzTitle]="'agentBuilder.title'|translateTA" [nzExtra]="cardExitTemplate" [nzLoading]="loading">
    <nz-tabs #tabs>
        <nz-tab nzTitle="{{'agentBuilder.configurations' | translateTA}}">
            <form nz-form [formGroup]="form" nzLayout="horizontal" nzLabelAlign="right" [nzLayout]="'vertical'">
                <nz-form-item >
                    <nz-form-label>{{'agentBuilder.agentname' | translateTA}}</nz-form-label>
                    <nz-form-control>
                        <input nz-input formControlName="agentName">
                    </nz-form-control>
                </nz-form-item>

                <div nz-row [nzGutter]="8">
                    <div nz-col [nzSpan]="12">
                        <nz-form-item>
                            <nz-form-label>Stream</nz-form-label>
                            <nz-form-control>
                                <nz-switch formControlName="stream"></nz-switch>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div nz-col [nzSpan]="12">
                        <nz-form-item>
                            <nz-form-label>{{'agentBuilder.autonomo'| translateTA}}</nz-form-label>
                            <nz-form-control>
                                <nz-switch formControlName="autonomo"></nz-switch>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </div>

                <nz-form-item>
                    <nz-form-label>{{'agentbuilder.codecontract' | translateTA}}</nz-form-label>
                    <nz-form-control>
                        <search-input-new [searchProperties]="searchInputCodeContract" (onChangeData)="onChangeCodeCodeContract($event)" class="full-width" formControlName="codecontract"></search-input-new>
                        <!--input nz-input formControlName="codecontract"-->
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                    <nz-form-label>{{'agentbuilder.codecompany' | translateTA}}</nz-form-label>
                    <nz-form-control>
                        <!--input nz-input formControlName="codecompany"-->
                        <search-input-new [searchProperties]="searchInputCodeCompany"  [variables]="variables" [changes]="changeCodeContract"  class="full-width" formControlName="codecompany"></search-input-new>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item >
                    <nz-form-label>{{'agentBuilder.llm' | translateTA}} ( Large Language Model )</nz-form-label>
                    <nz-form-control>
                        <nz-select formControlName="llm"  [nzCustomTemplate]="selectedValueTemplate">
                            @for ( model of (modelsData|async); track model) {
                                 <nz-option [nzValue]="model.llm" nzCustomContent [nzLabel]="model.name">
                                    <nz-icon [nzType]="model.icon"></nz-icon>
                                    {{model.name}}
                                 </nz-option>
                            }   
                        </nz-select>
                        <ng-template #selectedValueTemplate let-selected>
                            @let dataOption = getModel(selected.nzValue);
                             <nz-icon [nzType]="dataOption.icon"></nz-icon>
                            {{ selected?.nzLabel }}
                        </ng-template>

                    </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                    <nz-form-label>{{'agentBuilder.model' | translateTA}}</nz-form-label>
                    <nz-form-control>
                        <nz-select formControlName="model">
                            @for ( model of models; track model) {
                                <nz-option [nzValue]="model" [nzLabel]="model"></nz-option>
                            }   
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                    <nz-form-label>Embed Model</nz-form-label>
                    <nz-form-control>
                        <nz-select formControlName="embeedModel">
                            @for ( model of embeedModels; track model) {
                                <nz-option [nzValue]="model" [nzLabel]="model"></nz-option>
                            } 
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label>API Key</nz-form-label>
                    <nz-form-control>
                        <input nz-input type="password" formControlName="apiKey">
                    </nz-form-control>
                </nz-form-item>

                <nz-row [nzGutter]="16">
                    <nz-col nzSpan="6">
                        <nz-form-item>
                            <nz-form-label>{{'agentBuilder.temperature'|translateTA}}</nz-form-label>
                            <nz-form-control>
                                <input nz-input type="text" formControlName="temperature">
                            </nz-form-control>
                        </nz-form-item>
                    </nz-col>
                    <nz-col nzSpan="6">
                        <nz-form-item>
                            <nz-form-label>{{'agentBuilder.maxTokens'|translateTA}}</nz-form-label>
                            <nz-form-control>
                                <input nz-input type="number" formControlName="maxTokens">
                            </nz-form-control>
                        </nz-form-item>
                    </nz-col>
                    <nz-col nzSpan="6">
                        <nz-form-item>
                            <nz-form-label>{{'agentBuilder.topP'|translateTA}}</nz-form-label>
                            <nz-form-control>
                                <input nz-input type="number" formControlName="topP">
                            </nz-form-control>
                        </nz-form-item>
                    </nz-col>
                </nz-row>
                    
                <nz-divider nzPlain nzVariant="solid" nzText="{{'agentBuilder.databaseconfiguration' | translateTA}}"></nz-divider>

                <nz-form-item>
                    <nz-form-label>{{'agentBuilder.databasename' | translateTA}}"</nz-form-label>
                    <div class="item-form-group">
                        <nz-form-control>
                        <!--input nz-input formControlName="dbName"-->
                            <search-input-new [searchProperties]="searchDBNAME" class="full-width" formControlName="dbName" [variables]="variables" [changes]="changeCodeContract"
                            (onSelect)="onDatabaseSelect($event)"></search-input-new>
                        </nz-form-control>
                        <button nz-button nzType="primary"  (click)="createDatabase()" nz-tooltip  [nzTooltipTitle]="'agentBuilder.createdatabasename'|translateTA">
                                <nz-icon nzType="database" nzTheme="outline"></nz-icon>
                        </button>
                    </div>
                </nz-form-item>
                <nz-collapse nzBordered="true" class="card-board" >
                    <nz-collapse-panel nzcoll nzHeader="{{'agentBuilder.databaseconfiguration.advanced' | translateTA}}" [nzDisabled]="form.get('dbName').value == null || form.get('dbName').value == ''" [nzActive]="false">
                    
                        <nz-row [nzGutter]="16">
                            <nz-col nzSpan="12">
                                <nz-form-item>
                                <nz-form-label>QA Table</nz-form-label>
                                <nz-form-control>
                                    <input nz-input formControlName="qaTable">
                                </nz-form-control>
                                </nz-form-item>
                            </nz-col>

                            <nz-col nzSpan="12">
                                <nz-form-item>
                                <nz-form-label>Log Autonumus Table</nz-form-label>
                                <nz-form-control>
                                    <input nz-input formControlName="alTable">
                                </nz-form-control>
                                </nz-form-item>
                            </nz-col>

                            <nz-col nzSpan="12">
                                <nz-form-item>
                                <nz-form-label>Feedback Table</nz-form-label>
                                <nz-form-control>
                                    <input nz-input formControlName="fbTable">
                                </nz-form-control>
                                </nz-form-item>
                            </nz-col>

                            <nz-col nzSpan="12">
                                <nz-form-item>
                                <nz-form-label>FeedBack Vector Index</nz-form-label>
                                <nz-form-control>
                                    <input nz-input formControlName="fbVectorIndexName">
                                </nz-form-control>
                                </nz-form-item>
                            </nz-col>

                            <nz-col nzSpan="12">
                                <nz-form-item>
                                <nz-form-label>KB Table</nz-form-label>
                                <nz-form-control>
                                    <input nz-input formControlName="kbTable">
                                </nz-form-control>
                                </nz-form-item>
                            </nz-col>

                            <nz-col nzSpan="12">
                                <nz-form-item>
                                <nz-form-label>KB Vector Index Name</nz-form-label>
                                <nz-form-control>
                                    <input nz-input formControlName="kbVectorIndexName">
                                </nz-form-control>
                                </nz-form-item>
                            </nz-col>

                    
                        </nz-row>           
                    </nz-collapse-panel>     
                </nz-collapse>
            </form>
            @if (form.get('autonomo')?.value == true){
                    <nz-divider nzPlain nzVariant="solid" nzText="{{'agentBuilder.autonomoConfiguration' | translateTA}}"></nz-divider>
                    <form  nz-form [formGroup]="form" nzLayout="horizontal" nzLabelAlign="right" [nzLayout]="'vertical'">
                        <nz-form-item>
                                <nz-form-label>{{'agentBuilder.maxIterator'| translateTA}}</nz-form-label>
                                <nz-form-control>
                                    <input nz-input type="number" formControlName="maxIterator">
                                </nz-form-control>
                        </nz-form-item>
                         <nz-form-item>
                                <nz-form-label>{{'agentBuilder.cron'| translateTA}}</nz-form-label>
                                <nz-form-control>
                                    
                                    
                                    <nz-space-compact [style.width.%]="100">
                                        <input #inputValue nz-input formControlName="cron"  [placeholder]="'agentBuilder.cron'|translateTA" [type]="'text'"/>
                                        <button nz-button nzType="primary" nzSearch (click)="openScheduleComponent($event)" >
                                            <nz-icon [nzType]="'clock-circle'" />
                                        </button>
                                    </nz-space-compact>
                                
                                </nz-form-control>
                        </nz-form-item>
                    </form>

                    <nz-collapse nzBordered="true" class="card-board" >
                        <nz-collapse-panel nzHeader="{{'agentBuilder.goal'|translateTA}}">
                            <nz-table [nzData]="form.get('goal').value" #tableGoal nzBordered nzSize="small">
                                <tbody>
                                    <tr *ngFor="let item of tableGoal.data; let i = index">
                                        <td (click)="editGoal(i)" style="cursor: pointer;">
                                            <ng-container *ngIf="editGoalIndex !== i; else editTpl">
                                            {{ item }}
                                            </ng-container>

                                            <ng-template #editTpl>
                                            <input
                                                nz-input
                                                [(ngModel)]="items[i]"
                                                (blur)="stopEditGoal()"
                                                (keyup.enter)="stopEditGoal()" />
                                            </ng-template>
                                        </td>
                                        <td style="width: 40px; text-align: center;">
                                            <button
                                            nz-button
                                            nzType="link"
                                            nzDanger
                                            (click)="removeGoal(i); $event.stopPropagation()">
                                            x
                                        </button>

                                    </tr>

                                    <!-- Linha para adicionar -->
                                    <tr>
                                        <td>
                                            <input
                                            nz-input
                                            placeholder="Adicionar..."
                                            [(ngModel)]="newGoalItem"
                                            (keyup.enter)="addGoal()" />
                                        </td>
                                    </tr>
                                </tbody>
                            </nz-table>
                        </nz-collapse-panel>
                    </nz-collapse>
                }
            
        </nz-tab>
        <nz-tab [nzTitle]="'+' + ('agentBuilder.configurations'|translateTA)" >
            
        @if (form.get('systemPromptHistory')?.value?.length > 0) {
            <div class="system-prompt-history">
                <nz-select class="system-prompt-history-select"
                    [(ngModel)]="historySelected"
                    ngModelOptions="{standalone: true}"
                    [nzPlaceHolder]="'agentBuilder.systemPromptHistory'|translateTA">
                    @for (history of form.get('systemPromptHistory')!.value; track $index; let i = $index) {
                        <nz-option 
                            [nzValue]="i" 
                            [nzLabel]="(fixDate(history.updatedAt) | date:'yyyy-MM-dd HH:mm:ss' )+' - '+history.userName">
                        </nz-option>
                    }
                </nz-select>

                    <button 
                            nz-button 
                            nzType="primary" 
                            (click)="selectHistoryPrompt();canRedoSystemPrompt=true"
                            style="margin-bottom: 16px">
                            {{'agentBuilder.selectPrompt'|translateTA}}
                    </button>
                </div>
            }
            
            @if ( !form.get('systemPrompt').pristine || canRedoSystemPrompt ){
                <button class="system-prompt-history-redo" nz-button nzType="text" nz-tooltip="{{ 'agentBuilder.redo' |translateTA }}" (click)="form.get('systemPrompt').setValue(backupSystemPrompt);canRedoSystemPrompt=false;form.get('systemPrompt').markAsPristine()" [disabled]="!canRedoSystemPrompt && form.get('systemPrompt').pristine">
                    <nz-icon nzType="redo" nzTheme="outline"></nz-icon>
                </button>
            }

            <form nz-form [formGroup]="form" nzLabelAlign="right" [nzLayout]="'vertical'">
                 
                <nz-form-item>
                    <nz-form-label>{{'agentBuilder.systemprompt'|translateTA}}</nz-form-label>
                    <nz-form-control>
                        <!--textarea nz-input rows="8" formControlName="systemPrompt"></textarea-->
                        <div class="quill-container">
                            <quill-editor class="quill-container"  formControlName="systemPrompt" [format]="'html'" [styles]="{'min-height': (8 * 30) + 'px','width':'100%', 'height':'250px'}"></quill-editor>
                        </div>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                    <nz-form-label>{{'agentBuilder.devprompt'|translateTA}}</nz-form-label>
                    <nz-form-control>
                        <textarea nz-input rows="8" formControlName="devMessage"></textarea>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                    <nz-form-label>{{'agentBuilder.welcomemessage'|translateTA}}</nz-form-label>
                    <nz-form-control>
                        <textarea nz-input rows="8" formControlName="welcomeMessage"></textarea>
                    </nz-form-control>
                </nz-form-item>
            </form>
        </nz-tab>
        <nz-tab nzTitle="{{'agentBuilder.kbTitle'|translateTA}}">
            <agent-builder-kb-upload [agent]="agent"></agent-builder-kb-upload>
        </nz-tab>
        <nz-tab nzTitle="MCPS">
            <div class="tab-container">
                <form nz-form [formGroup]="form" nzLabelAlign="right" nzLayout="vertical">
                    
                        <button 
                            nz-button 
                            nzType="primary" 
                            (click)="openAddMcpModal()"
                            style="margin-bottom: 16px">
                            + {{'agentBuilder.addmcp'|translateTA}}
                        </button>

                        <div class="tab-container">
                        <nz-table
                            nzBordered
                            [nzNoResult]="emptyTemplate"
                            [nzLoading]="mcpLoading"
                            [nzShowPagination]="true"
                            [(nzPageIndex)]="mcpPageIndex"
                            [nzPageSize]="3"
                            [nzData]="mcps"
                            [nzScroll]="{ y: 'calc(100vh - 390px)' }"
                            #tableMcp
                            class="full-table">

                            <thead>
                                <tr>
                                    <th>{{'agentBuilder.idhook'|translateTA}}</th>
                                    <th>{{'agentBuilder.url'|translateTA}}</th>
                                    <th>{{'agentBuilder.tools'|translateTA}}</th>
                                    <th>{{'agentBuilder.actions'|translateTA}}</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let group of tableMcp.data; let i = index" >
                                    <td>{{ group?.idhook?.key }} - {{ group?.idhook?.value }}</td>
                                    <td>{{ group?.url }}</td>
                                    <td>{{ getToolNames(group) }}</td>
                                    <td style="white-space: nowrap;">
                                        <button nz-button nzType="primary" nzSize="small" (click)="editMcp(i)" style="margin-right: 8px">
                                            {{'agentBuilder.edit'|translateTA}}
                                        </button>
                                        <button nz-button nzDanger nzSize="small" (click)="deleteMcp(i)">
                                            {{'agentBuilder.delete'|translateTA}}
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </nz-table>
                    
                </div>
                </form>
            </div>
        </nz-tab>
        <nz-tab nzTitle="{{'agentBuilder.subagents'|translateTA}}">
            <agent-builder-subagents [agent]="agent" [form]="form" [variables]="variables"></agent-builder-subagents>
        </nz-tab>
        <nz-tab nzTitle="{{'agentBuilder.promptTitle'|translateTA}}">
            <agent-builder-prompt [agent]="agent"></agent-builder-prompt>
        </nz-tab>
        <nz-tab nzTitle="{{'agentBuilder.messageLogTitle'|translateTA}}">
            <agent-builder-messages-log [agent]="agent"></agent-builder-messages-log>
        </nz-tab>
        <nz-tab nzTitle="{{'agentBuilder.mcpLogTitle'|translateTA}}">
            <agent-builder-mcp-log [agent]="agent"></agent-builder-mcp-log>
        </nz-tab>
    </nz-tabs>
    <button nz-button nzType="primary" (click)="save()" class="salvar-agent-button" *ngIf="showSaveButton">Salvar Agente</button>
</nz-card>

<!-- Modal para adicionar/editar MCP -->
<nz-modal
  [(nzVisible)]="showMcpModal"
  [nzTitle]="editingIndexMcp>-1 ? ('agentBuilder.editmcp'|translateTA) : ('agentBuilder.addmcp'|translateTA)"
  nzOkText="{{'agentBuilder.save'|translateTA}}"
  nzCentered="true"
  nzCancelText="{{'agentBuilder.cancel'|translateTA}}"
  nzWidth="80vw"
  nzHeight="95vh"
  (nzOnOk)="saveMcp()"
  (nzOnCancel)="closeMcpModal()">
    <ng-container *nzModalContent>
        <form nz-form [formGroup]="mcpForm">
            <nz-form-item>
                <nz-form-label>{{'agentbuilder.localmcp' | translateTA}}</nz-form-label>
                <nz-form-control>
                    <nz-switch formControlName="local"></nz-switch>
                </nz-form-control>    
            </nz-form-item>
            <nz-divider nzPlain nzVariant="solid"  style="background-color: rgb(220, 220, 220);" ></nz-divider>
            @if( switchValueMCPMode ){
                <nz-form-item>
                    <nz-form-label>{{'agentbuilder.idhook' | translateTA}}</nz-form-label>
                    <nz-form-control>
                        <search-input-new [searchProperties]="searchWebHook" class="full-width" formControlName="idhook"
                        #searchInputIdhook
                        (onChangeData)="onChangeTools($event)"
                        ></search-input-new>
                    </nz-form-control>
                </nz-form-item>
            }@else{
                <nz-form-item>
                    <nz-form-label>URL</nz-form-label>
                    <nz-form-control nzErrorTip="{{'agentBuilder.urlrequired'|translateTA}}">
                        <input 
                        nz-input 
                        formControlName="url" 
                        placeholder="http://localhost:3000">
                    </nz-form-control>
                </nz-form-item>
            }
            
            <nz-form-item>
                <nz-form-label>{{'agentBuilder.tools'|translateTA}}</nz-form-label>
                <div class="item-form-group">
                    <nz-form-control>
                        <nz-select 
                            [compareWith]="compareTools"
                            formControlName="tools" 
                            nzMode="multiple"
                            nzPlaceHolder="{{'agentBuilder.selecttools'|translateTA}}">
                            <nz-option *ngFor="let tool of filteredListOfTool[0]?.tools" [nzValue]="tool" [nzLabel]="(tool.name==null?tool:tool.name) + (tool.description ? ' - ' + tool.description : '')"></nz-option>
                        </nz-select>
                    </nz-form-control>
                    <button nz-button nzType="primary" nzSize="small" (click)="loadMcpTools()" [nzLoading]="loadingMcp" *ngIf="!switchValueMCPMode">
                        {{'agentBuilder.finddata'|translateTA}}
                    </button>
                </div>
            </nz-form-item>
            <nz-form-item *ngIf="!switchValueMCPMode">
                <nz-form-label>{{'agentBuilder.header'|translateTA}}</nz-form-label>
                <nz-table [nzData]="mcpForm.get('header')?.value || []" nzBordered #tableHHeader class="tab-container" [nzScroll]="{ y: 'calc(100vh - 500px)' }">
                    <thead>
                        <tr>
                            <th>Chave</th>
                            <th>Valor</th>
                            <th style="width: 80px;">{{'agentBuilder.actions'|translateTA}}</th>
                        </tr>
                    </thead>
                     
                    <tbody>
                        <tr class="row-insert-table">
                            <td>
                                <input nz-input placeholder="{{'agentBuilder.newKey'|translateTA}}"  [(ngModel)]="newKey" [ngModelOptions]="{standalone: true}"/>
                            </td>
                            <td>
                                <input nz-input placeholder="{{'agentBuilder.newKey'|translateTA}}" [(ngModel)]="newValue" [ngModelOptions]="{standalone: true}"/>
                            </td>
                            <td>
                                <button nz-button nzType="primary" nzSize="small" (click)="addHeader()">
                                    {{'agentBuilder.add'|translateTA}}
                                </button>
                            </td>
                        </tr>
                        <tr *ngFor="let item of tableHHeader.data; let i = index">
                            <td>
                                <input
                                nz-input
                                [(ngModel)]="item.key"
                                [ngModelOptions]="{standalone: true}"
                                />
                            </td>

                            <td>
                                <input
                                nz-input
                                [(ngModel)]="item.value"
                                [ngModelOptions]="{standalone: true}"
                                />
                            </td>

                            <td>
                                <button nz-button nzDanger nzSize="small" (click)="removeHeader(i)">
                                    {{'agentBuilder.remove'|translateTA}}
                                </button>
                            </td>
                        </tr>
                       
                    </tbody>
                </nz-table>
            </nz-form-item>
        </form>
    </ng-container>
</nz-modal>

<ng-template #cardExitTemplate>
    <button nz-button nzType="default" nzShape="circle" (click)="closeConfig()">
        <nz-icon  nzType="close" nzTheme="outline"  />
    </button>
    
</ng-template>

<ng-template #emptyTemplate >
           <nz-empty 
              nzNotFoundContent="Nenhum mcp adicionado"
              style="margin: 0">
            </nz-empty>
</ng-template>